import { useReduxState } from 'hooks';

interface Props {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const ModalFooter = ({ children, style }: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="modal-footer" style={style}>
      {children}

      <style jsx>{`
        .modal-footer {
          border-top: 1px solid ${theme.lightGrey};
          padding: 15px;
          text-align: right;
        }
        .modal-footer :global(button:not(:first-child)) {
          margin-left: 10px;
        }
      `}</style>
    </div>
  );
};

export default ModalFooter;
